import CompLayout from "@/pcomponents/comp/layout/layout";
import DiscoverMapListCalendar from "@/pages/comp/edu/discover_map/common/list_calendar";

function DiscoverMapListCalendarPage() {
  
  return (
    <CompLayout isConTitle={false}>
      <DiscoverMapListCalendar></DiscoverMapListCalendar>
    </CompLayout>
  );
};
export default DiscoverMapListCalendarPage;